export enum PDFAConformance {
  e_Level1A = 1,
  e_Level1B = 2,
  e_Level2A = 3,
  e_Level2B = 4,
  e_Level2U = 5,
  e_Level3A = 6,
  e_Level3B = 7,
  e_Level3U = 8,
  e_Level4 = 9,
  e_Level4E = 10,
  e_Level4F = 11,
}

export const PDFAConformanceRecord: Record<PDFAConformance, string> = {
  [PDFAConformance.e_Level1A]: 'Level 1A',
  [PDFAConformance.e_Level1B]: 'Level 1B',
  [PDFAConformance.e_Level2A]: 'Level 2A',
  [PDFAConformance.e_Level2B]: 'Level 2B',
  [PDFAConformance.e_Level2U]: 'Level 2U',
  [PDFAConformance.e_Level3A]: 'Level 3A',
  [PDFAConformance.e_Level3B]: 'Level 3B',
  [PDFAConformance.e_Level3U]: 'Level 3U',
  [PDFAConformance.e_Level4]: 'Level 4',
  [PDFAConformance.e_Level4E]: 'Level 4E',
  [PDFAConformance.e_Level4F]: 'Level 4F',
}

export type ViewerMimeTypes =
  | 'application/pdf'
  | 'application/msword'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/octet-stream'

export interface ViewerDocument {
  guid: string
  name: string
  url: string
  fileType: ViewerMimeTypes
  editingDisabled?: boolean
  watermark?: {
    diagonal?: {
      fontSize: number
      fontFamily: string
      color: string
      opacity: number
      text: string
    }
    header?: {
      fontSize: number
      fontFamily: string
      color: string
      opacity: number
      left: string
      center: string
      right: string
    }
  }
}
